import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

interface IUpdateRequestBody {
  clinic_id: string;
  target_status: "draft" | "pending";
  items: Array<{
    unique_row_id: string;
    qty: number;
    inventory_type: string;
  }>;
}

interface IUpdateRequestResponse {
  status: boolean;
  message: string;
  data?: unknown;
}

export const useUpdateClinicToDoctorRequestAPI = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();

  const execute = useCallback(async (requestId: string, body: IUpdateRequestBody): Promise<{ status: boolean }> => {
    setIsSubmitting(true);
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      const res = await axios.put<IUpdateRequestResponse>(
        `${INVENTORY_MODULE.CLINIC_TO_DOCTOR_REQUEST.baseURL}/${requestId}`,
        body,
        {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (res.data.status === true) {
        toast.success(res.data.message || "Transfer request updated successfully");
        return { status: true };
      } else {
        toast.error(res.data.message || "Failed to update transfer request");
        return { status: false };
      }
    } catch (e: any) {
      if (e instanceof AxiosError) {
        captureError(e);
      }
      toast.error(e?.response?.data?.message || "Failed to update transfer request");
      return { status: false };
    } finally {
      setIsSubmitting(false);
    }
  }, []);

  return { execute, isSubmitting };
};
